import React, { useEffect, useState } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import Chart from '../../../components/chart/Chart'
import { doc, getDoc, onSnapshot, updateDoc } from "firebase/firestore"
import {  Link, useParams } from "react-router-dom"
import { db } from '../../../firebase'
import ConfirmStatusBox from '../../../components/ConfirmStatusBox'
import { getFunctions, httpsCallable } from "firebase/functions";

const Single = ({user}) => {

  const {partnerRewardId} = useParams()


  const [ partnerData, setPartnerData ] = useState("")

  const [openStatus, setOpenStatus] = useState(false)


  const getpartnerInfo = () => {

    onSnapshot(doc(db, "partners", partnerRewardId), (doc) => {
  
     console.log("Current data: ", doc.data());
  
  
    setPartnerData({id: doc.id, ...doc.data()})
  
    
   });
  
  
  }

  useEffect(()=>{

    getpartnerInfo()
    

  }, [])


  const removeAdmin = async() => {

    const functions = getFunctions();
    const callableFunction = httpsCallable(functions, 'removeAdmin');
    const result = await callableFunction({ email: partnerData.email });

  }

  const addAdmin = async() => {

    const functions = getFunctions();
    const callableFunction = httpsCallable(functions, 'addAdmin');
    const result = await callableFunction({ email: partnerData.email });

     
  }



    const handleStatus = async() => {

      partnerData.status === "active" ? removeAdmin() : addAdmin()

      const adminRef = doc(db, "partners", partnerRewardId);
  
      await updateDoc(adminRef, {
  
      status: partnerData.status === "active" ? 'inactive' : 'active', 
  
   })
  
    setOpenStatus(false)
  
    }


  
  //   const handleStatus = async() => {
  
      
  //     const adminRef = doc(db, "admins", partnerRewardId);
  
  //     await updateDoc(adminRef, {
  
  //     status: partnerData.status === "active" ? 'inactive' : 'active', 
  
  //  })
  
  //   setOpenStatus(false)
  
  //   }
  




  return (
    <>

<div className='single'>
      <Sidebar/>
      <div className='singleContainer'>
        
        <Navbar/>
      
        <div className="top">
            
          <div className="left">

           <div style = {{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center', paddingLeft:20, paddingRight:20, }}>

            <h2 className='title'>Partner Information</h2>
             <Link to={`/partnerReward/edit/${partnerRewardId}`} 
                style={{ border: '1px solid gray', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:"", cursor:'pointer'}}>
                <span style={{color:'black', fontWeight:'bold'}}>Edit Details</span>
            </Link>

           </div>
        
            <div className='item'>

                <img
                  src = {partnerData.imgpartner}
                  alt="avatar"
                  style={{width:'100px', height:'100px', borderRadius:'50%'}}
                    
                /> 
         
               
                <div className="details">
                  <div style={{flexDirection:'row', alignItems:'center'}}>
                    <h3 className='itemTitle'>{partnerData.firstname} {partnerData.partnername}</h3>
                  </div>

                
                  <div className='detailItem'>
                    <span className='itemKey'>Partner Role:</span>
                    <span className='itemValue'>{partnerData.role === "admin" ? "Partner Admin" : "Member"}</span>
                  </div>

                  <div className='detailItem'>
                    <span className='itemKey'>Partner Address:</span>
                    <span className='itemValue'>{partnerData.role}</span>
                  </div>

                  <div className='detailItem'>
                    <span className='itemKey'>Date:</span>
                    <span className='itemValue'>{partnerData.date}</span>
                  </div>

                  <div className='detailItem'>
                    <span className='itemKey'>Email:</span>
                    <span className='itemValue'>{partnerData.email}</span>
                  </div>

                   <div className='detailItem'>
                    <span className='itemKey'>State:</span>
                    <span className='itemValue'>{partnerData.region}</span>
                  </div>

                   <div className='detailItem'>
                    <span className='itemKey'>Area:</span>
                    <span className='itemValue'>{partnerData.area}</span>
                  </div>
              
                </div>

              

            </div>
          </div>
          <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <div style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>

                  <h2 className='title'>Access Status</h2>

                  <a onClick={(event)=> {event.preventDefault(); setOpenStatus(true);}}  style={{ border: '1px solid green', borderRadius:'5px', justifyItems:'center', alignItems:'center', textDecoration:'none', paddingTop:'10px', paddingBottom:'10px', paddingRight:'40px', paddingLeft:'40px', backgroundColor:partnerData.status === "active" ? "green" : "red", cursor:'pointer'}}>
                          <span style={{color:'white', fontWeight:'bold'}}>{partnerData.status === "active" ? "Active" : "Inactive"}</span>
                  </a>
              

            </div>


          </div>
        
        </div>
      
      </div>
     
    </div>
      <ConfirmStatusBox
        openStatus={openStatus}
        closeDialog={() => setOpenStatus(false)}
        statusFunction={handleStatus }
      />
    </>
 
  )
}

export default Single

